var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.debouncedApolloLoading)?_c('span',{staticClass:"apollo-spinner text-green-500"}):_vm._e(),_c('scrolling-video-gallery',_vm._g({attrs:{"videos":_vm.videos,"load-more":_vm.loadMore}},_vm.$listeners))],1)}
var staticRenderFns = []

export { render, staticRenderFns }